import { Component, Input, OnInit, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { SearchResultsModel } from '../../models/search-results-model';
import { DialogService } from 'primeng/dynamicdialog';
import { AdamsDocModel } from '../../models/adams-doc-model';
import { ResultColumnsService } from '../../services/result-columns.service';
import { ResultSelectionService } from '../../services/result-selection.service';
import { DocumentDownloadService } from '../../services/document-download.service';
import { ConstantsService } from '../../services/constants.service';
import { MessageService } from 'primeng/api';
import { DownloadRequest } from '../../models/download-req-model';
import { FoldersService } from '../../services/folders.service';

@Component({
  selector: 'app-results-table-view',
  templateUrl: './results-table-view.component.html',
  styleUrls: ['./results-table-view.component.css']
})
export class ResultsTableViewComponent implements OnInit, OnChanges {

  @Input() viewItems: SearchResultsModel[] = [];
  @Input() loading: boolean = false;
  @Input() totalCount: number = 0;
  @Output() docDetails = new EventEmitter();
  @Output() shareLink = new EventEmitter();
  @Output() addNewCols = new EventEmitter();

  selectedCols: any[] = [];

  showReportDialog: boolean = false;
  showDownloadDialog: boolean = false;

  progress: number = 0;
  cancelDownload = false;
  isDownloading = false;
  isExcelDownload = true;
  downloadFileType: string = 'Excel';
  downloadOption: string = 'all';
  selectedProps: any[] = [];

  tableSelections?: SearchResultsModel;
  allItemsSelected: boolean = false;
  allExceptSelected: boolean = false;
  currentIndex: string;

  constructor(public dialogService: DialogService,
    private resultColSvc: ResultColumnsService,
    private selectionSvc: ResultSelectionService,
    private downloadDocSvc: DocumentDownloadService,
    private constantsSvc: ConstantsService,
    private messageSvc: MessageService,
    private folderSvc: FoldersService,
    public constants: ConstantsService
  ) {
     this.currentIndex = this.constants.indexEHD;
  }

  ngOnInit(): void {
    this.allItemsSelected = false;
    //Subscribe to the SelectedCols in the Columns Service
    this.resultColSvc.selectedCols$.subscribe(cols => { this.selectedCols = cols; });
    this.selectionSvc.allSelected$.subscribe(allSelected => { this.allItemsSelected = allSelected; });
    this.selectionSvc.allExcept$.subscribe(allEx => { this.allExceptSelected = allEx; });
    this.folderSvc.selectedLibrary$.subscribe((l) => {
      this.currentIndex = l;
    });
  }

  ngOnChanges(changes: SimpleChanges) {

  }

  showProperties(item: AdamsDocModel) {
    this.docDetails.emit(item);
  }

  showShare(doc: SearchResultsModel) {
    this.shareLink.emit(doc);
  }

  reorderSortSelections() {
    this.selectedCols.sort((a: any, b: any) => {
      return a.header.localeCompare(b.header);
    });
  }

  //Checkboxes
  toggleAllRows(event: any): void {
    //Set All Selected to the value of the top checkbox
    const isChecked = event.target.checked;
    this.selectionSvc.setAllSelected(isChecked);

    if (!this.allItemsSelected) {
      this.selectionSvc.clearAll();
    }
    else {
      this.selectionSvc.clearExcluded();
      this.selectionSvc.clearSelected();
      this.selectionSvc.setallSelectedWithLegacy(this.viewItems);
    }
  }

  onRowSelectChange(rowData: SearchResultsModel, event: any) {
    const cbxValue = event.target.checked
    rowData.selected = cbxValue;

    if (this.allItemsSelected) {
      this.selectionSvc.setAllSelected(false);
      this.selectionSvc.setAllExcept(true);
      this.selectionSvc.clearExcluded();
    }

    this.setRowSelection(rowData);
  }

  getRowSelection(rowData: SearchResultsModel) {
    return this.selectionSvc.isItemSelected(rowData);
  }

  setRowSelection(rowData: SearchResultsModel) {
    if (rowData.selected) {
      this.selectionSvc.addToSelectedArray(rowData);
    } else {
      if (this.selectionSvc.isAllExcept()) {
        this.selectionSvc.addToExcludedArray(rowData);
      }
      else {
        this.selectionSvc.removeFromSelectedArray(rowData);
      }
    }
  }

  downloadDocument(doc: AdamsDocModel) {

    if (!doc || !doc.AccessionNumber) {
      return;
    }

    const accessionNumber = doc?.AccessionNumber;
    const isPackage = doc.IsPackage;

    let items: DownloadRequest = {accessionNumbers: [], indexId: this.currentIndex};

    if (isPackage === this.constantsSvc.DocItemYes) {
      //Add the package items to the list
      if (doc.DocumentsFiledInPackage) {
        items.accessionNumbers = doc.DocumentsFiledInPackage;
      }
    } else {
      items.accessionNumbers.push(accessionNumber);
    }

    if (items.accessionNumbers.length > 0) {
      this.messageSvc.add({ key:'downloadFiles'  ,severity: 'success', summary: 'Download Started', detail: 'Your file(s) are being downloaded!' });

      this.downloadDocSvc.getDocuments(items).subscribe({
        next: (blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'documents.zip';
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          this.messageSvc.add({ key:'downloadFiles'  ,severity: 'success', summary: 'Download Complete', detail: 'Your have been downloaded!' });
        },
        error: (err) => {
          // console.error('Download Error', err);
          this.messageSvc.add({ key:'downloadFiles'  ,severity: 'danger', summary: 'Download Failed', detail: 'There was an issue downloading your files.' });
        }
      });
    }
  }
}
